import Vue from 'vue';
import Vuex from 'vuex';
import dotenv from 'dotenv';
import router from '@/router/index.js';

import { DateTime } from 'luxon';

import i18n from '@/plugins/i18n';

import Cookies from 'js-cookie';

import { helpers } from '@/store/helpers.js';
import { getLang, setLocalLang } from '@/helpers/language';
import { IS_LOCAL } from '@/helpers';

import auction from '@/store/auction.js';
import events from '@/store/events.js';
import mainNotice from '@/store/mainNotice.js';
import themeStore from '@/store/theme.js';
// import web3Store from '@/store/web3.js';
import megaLotto from '@/store/mega_lotto';
import pickTheFate from '@/store/pick_the_fate';
import events2025January from '@/store/events/2025/january';
import events2025LunarNewYear from '@/store/events/2025/lunar_new_year';
import events2025Valentine from '@/store/events/2025/valentine';
import events2025Barbeque from '@/store/events/2025/barbeque';
import events2025Spring from '@/store/events/2025/spring';
import events2025Growing from '@/store/events/2025/growing';
import events2025Dalgona from '@/store/events/2025/dalgona';
import events2025Environment from '@/store/events/2025/environment';
import events2025IceCream from '@/store/events/2025/ice_cream';
import events2026NewYear from '@/store/events/2026/newyear';

dotenv.config();

Vue.use(Vuex);

// Vuex Store
export default new Vuex.Store({
  modules: {
    // NOTE: Events
    events2025January,
    events2025LunarNewYear,
    events2025Valentine,
    events2025Barbeque,
    events2025Spring,
    events2025Growing,
    events2025Dalgona,
    events2025Environment,
    events2025IceCream,
    events2026NewYear,
    // NOTE: Events
    AuctionStore: auction,
    EventsStore: events,
    MainNoticeStore: mainNotice,
    ThemeStore: themeStore,
    // Web3Store: web3Store,
    megaLotto,
    pickTheFate,
  },
  state: {
    vm: null,
    globalErrorModal: null,
    userData: null,
    userAssets: null,
    fromName: undefined,
    lang: null,
    dropEvent: null,
    attendanceEvent: null,
    holiday: null,
    // isMobile: helpers.getWindowWidth() < 1120,
    // isTablet: helpers.getWindowWidth() < 1345,
    realMobile: matchMedia('(max-width: 767px)').matches,
    isMobile: matchMedia('(max-width: 1120px)').matches,
    isTablet: matchMedia('(max-width: 1345px)').matches,
    heightFitContent: false,
    showWebtoonModal: false,
    showUrgentAlertModal: false,
    isPhone: false,
    showGuideModal: false,
    showEventModal: false,
    nftDetailData: {},
    showPropertyDetail: false,
    isLogin: false,
    userId: null,
    isTodayAttendance: false,
    isLandingEventModal: false,
    isLandingEvent: false,
    // isEventAttendance: false,
    visitFirst: false,
    newNoti: false,
    newAnnounce: false,
    newProperty: false,
    withDraw: false,
    loadingStatus: false,
    loadingContent: null,
    cnt_attendance: 0,
    total_token: '0.00',
    totalTokenZIndex: 11,
    usrClover: 0,
    usrRegTicket: 0,
    mobilePageTitle: null,
    userCode: '',
    niceAuth: false,
    niceIdDone: {
      success: true,
      content: '',
      cancelBtn: false,
    },
    currentEventPageName: '',
    // App vital details
    app: {
      name: 'OpenMeta City',
      version: process.env.PACKAGE_VERSION,
      copyright: helpers.getCurrentYear(),
    },

    // Default layout options
    layout: {
      header: true,
      sidebar: true,
      sideOverlay: true,
      footer: true,
    },

    // Default template settings
    // Various of them are also set in each layout variation under layouts/variations/ folder
    settings: {
      colorTheme: '', // 'amethyst', 'city', 'flat', 'modern', 'smooth'
      sidebarLeft: true,
      sidebarMini: false,
      sidebarDark: true,
      sidebarVisibleDesktop: false,
      sidebarVisibleMobile: false,
      sideOverlayVisible: false,
      sideOverlayHoverable: false,
      pageOverlay: true,
      headerFixed: true,
      headerDark: false,
      headerSearch: false,
      headerLoader: false,
      pageLoader: false,
      rtlSupport: false,
      sideTransitions: true,
      mainContent: '', // 'boxed', ''narrow'
    },
    badgeValue: null,
    badgeState: false,
    myTabMenu: false,
    ownAptCnt: [0, 0, 0, 0, 0, 0],
    isPreEvent: false,
    isOpenInfluencer: false,
    omcUpdate: false,
    showPhoneAuth: false,
    newCommunity: 'CommunityForm',
    innerHeight: 0,
    city: null,
  },
  getters: {
    /* getUserNfts:(state) => {
      return state.User_Info.data.myNfts
    },
    getUserInfo:(state) => {
      return state.User_Info.data
    },
    getIsLoginStatus: (state) => {
      return state.isLogin.status
    },
    getPayLandInformation: (state) => {
      return state.payLandInformation.data
    }, */
    getCity: ({ city }) => city,
    // Get App name
    appName: ({ app }) => app.name,
    niceAuth: ({ niceAuth }) => niceAuth,
    niceIdDone: ({ niceIdDone }) => niceIdDone,
    userCode: ({ userCode }) => userCode,
    // Get App version
    appVersion: ({ app }) => app.version,
    // Get App copyright year
    appCopyright: ({ app }) => app.copyright,
    // Get app color theme
    appColorTheme: ({ settings }) => settings.colorTheme,
    getWithDraw: ({ withDraw }) => withDraw,
    getMobile: ({ isMobile }) => isMobile,
    showPropertyDetail: ({ showPropertyDetail }) => showPropertyDetail,
    propertyDetailData: ({ propertyDetailData }) => propertyDetailData,
    showGuideModal: ({ showGuideModal }) => showGuideModal,
    showEventModal: ({ showEventModal }) => showEventModal,
    showUrgentAlertModal: ({ showUrgentAlertModal }) => showUrgentAlertModal,
    showWebtoonModal: ({ showWebtoonModal }) => showWebtoonModal,
    isPhone: ({ isPhone }) => isPhone,
    isLogin: ({ isLogin }) => isLogin,
    isMobile: ({ isMobile }) => isMobile,
    total_token: ({ total_token }) => total_token,
    usrClover: ({ usrClover }) => usrClover,
    usrRegTicket: ({ usrRegTicket }) => usrRegTicket,
    totalTokenZIndex: ({ totalTokenZIndex }) => totalTokenZIndex,
    heightFitContent: ({ heightFitContent }) => heightFitContent,
    mobilePageTitle: ({ mobilePageTitle }) => mobilePageTitle,
    holiday: ({ holiday }) => holiday,
    holidayName: ({ holiday }) => {
      return holiday?.data ? holiday.data.event_name : null;
    },
    holidayMap: ({ holiday }) => {
      return holiday?.data ? holiday.data.map : null;
    },
    holidayDate: ({ holiday }) => holiday?.date,
    isOpenInfluencer: ({ isOpenInfluencer }) => isOpenInfluencer,
    isPreEvent: ({ isPreEvent }) => isPreEvent,
    // windowLang: () => helpers.getWindowLang(),
  },
  mutations: {
    setHoliday(state, payload) {
      state.holiday = payload;
    },
    setCity(state, payload) {
      state.city = payload;
    },
    setIsEvent(state, payload) {
      const { dropEvent, attendanceEvent } = payload;
      // state.isEvent = payload.isEvent;
      state.dropEvent = { ...dropEvent };
      state.attendanceEvent = { ...attendanceEvent };
    },
    setNiceIdDone(state, payload) {
      state.niceIdDone.success = payload.success;
      state.niceIdDone.content = payload.content;
      state.niceIdDone.cancelBtn = payload.cancelBtn;
    },
    toggleMobileHeader(state) {
      // console.log('routeName', router.app._route.name);
      // console.log('toggleMobileHeader', helpers.setMobileHeader());
      state.mobilePageTitle = helpers.setMobileHeader();
    },
    toggleHeightFitContent(state) {
      state.heightFitContent = !state.heightFitContent;
    },
    toggleTotalTokenZIndex(state, payload) {
      state.totalTokenZIndex = payload.totalTokenZIndex;
    },
    total_token_update(state, payload) {
      state.total_token = payload.total_token;
    },
    toggleUrgentAlertModal(state, payload) {
      state.showUrgentAlertModal = payload.state;
    },
    toggleWebtoonModal(state, payload) {
      state.showWebtoonModal = payload.state;
    },
    toggleIsPhone(state) {
      state.isPhone = !state.isPhone;
    },
    toggleGuideModalMobile(state) {
      state.showGuideModal = !state.showGuideModal;
    },
    toggleEventModalMobile(state) {
      state.showEventModal = !state.showEventModal;
    },
    toggleGuideModal(state, payload) {
      state.showGuideModal = payload.state;
    },
    setNftDetailData(state, nftDetailData) {
      state.nftDetailData = nftDetailData;
    },
    togglePropertyDetail(state, payload) {
      state.showPropertyDetail = payload.state;
    },
    readNoti(state) {
      state.newNoti = false;
    },
    newNoti(state) {
      state.newNoti = true;
    },
    readAnnounce(state) {
      state.newAnnounce = false;
    },
    newAnnounce(state) {
      state.newAnnounce = true;
    },
    readProperty(state) {
      state.newProperty = false;
    },
    isWithDraw(state, payload) {
      state.withDraw = payload.withdraw;
    },
    changeAttendance(state) {
      state.isTodayAttendance = false;
    },
    changeLandingModal(state) {
      state.isLandingEventModal = false;
    },
    changeLandingEvent(state) {
      state.isLandingEvent = false;
    },
    checkMobile(state) {
      const test = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
      const mobile =
        (test.test(navigator.userAgent.toLowerCase()) && helpers.getWindowWidth() < 1120) ||
        helpers.getWindowWidth() < 1120;
      const tablet = helpers.getWindowWidth() < 1345;
      state.isMobile = mobile;
      state.isTablet = tablet;

      // return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    setRealMobile(state, e) {
      state.realMobile = e.matches;
    },
    setIsMobile(state, e) {
      state.isMobile = e.matches;
    },
    setIsTablet(state, e) {
      state.isTablet = e.matches;
    },
    setInfluencer(state) {
      state.isOpenInfluencer = DateTime.now() >= DateTime.fromISO('2023-02-20T00:30:00'); //인플루언서 탭이 열리는 시간
      state.isPreEvent = DateTime.now() <= DateTime.fromISO('2023-02-28T13:00:00'); //인플루언서 사전신청이 끝나고 리스트가 열리는 시간
    },
    setLayout({ layout }, { header, sidebar, sideOverlay, footer }) {
      layout.header = header;
      layout.sidebar = sidebar;
      layout.sideOverlay = sideOverlay;
      layout.footer = footer;
    },
    // Sets sidebar visibility (open, close, toggle)
    sidebar(state, payload) {
      const { mode } = payload;
      // const isDeskTop = helpers.getWindowWidth() > 1120;

      const changeSidebar = {
        open: () => {
          state.settings.sidebarVisibleDesktop = true;
          state.settings.sidebarVisibleMobile = true;
          document.body.classList.add('no-scroll');
        },
        close: () => {
          state.settings.sidebarVisibleDesktop = false;
          state.settings.sidebarVisibleMobile = false;
          document.body.classList.remove('no-scroll');
        },
        toggle: () => {
          // isDeskTop
          //   ? (state.settings.sidebarVisibleDesktop = !state.settings.sidebarVisibleDesktop)
          //   : (state.settings.sidebarVisibleMobile = !state.settings.sidebarVisibleMobile);
        },
      };
      changeSidebar[mode]();
    },
    // Sets sidebar mini mode (on, off, toggle)
    sidebarMini(state, payload) {
      if (helpers.getWindowWidth() > 1120) {
        if (payload.mode === 'on') {
          state.settings.sidebarMini = true;
        } else if (payload.mode === 'off') {
          state.settings.sidebarMini = false;
        } else if (payload.mode === 'toggle') {
          state.settings.sidebarMini = !state.settings.sidebarMini;
        }
      }
    },
    // Sets sidebar position (left, right, toggle)
    sidebarPosition(state, payload) {
      if (payload.mode === 'left') {
        state.settings.sidebarLeft = true;
      } else if (payload.mode === 'right') {
        state.settings.sidebarLeft = false;
      } else if (payload.mode === 'toggle') {
        state.settings.sidebarLeft = !state.settings.sidebarLeft;
      }
    },
    // Sets sidebar style (dark, light, toggle)
    sidebarStyle(state, payload) {
      if (payload.mode === 'dark') {
        state.settings.sidebarDark = true;
      } else if (payload.mode === 'light') {
        state.settings.sidebarDark = false;
      } else if (payload.mode === 'toggle') {
        state.settings.sidebarDark = !state.settings.sidebarDark;
      }
    },
    // Sets side overlay visibility (open, close, toggle)
    sideOverlay(state, payload) {
      if (payload.mode === 'open') {
        state.settings.sideOverlayVisible = true;
      } else if (payload.mode === 'close') {
        state.settings.sideOverlayVisible = false;
      } else if (payload.mode === 'toggle') {
        state.settings.sideOverlayVisible = !state.settings.sideOverlayVisible;
      }
    },
    // Sets side overlay hover mode (on, off, toggle)
    sideOverlayHover(state, payload) {
      if (payload.mode === 'on') {
        state.settings.sideOverlayHoverable = true;
      } else if (payload.mode === 'off') {
        state.settings.sideOverlayHoverable = false;
      } else if (payload.mode === 'toggle') {
        state.settings.sideOverlayHoverable = !state.settings.sideOverlayHoverable;
      }
    },
    // Sets page overlay visibility (on, off, toggle)
    pageOverlay(state, payload) {
      if (payload.mode === 'on') {
        state.settings.pageOverlay = true;
      } else if (payload.mode === 'off') {
        state.settings.pageOverlay = false;
      } else if (payload.mode === 'toggle') {
        state.settings.pageOverlay = !state.settings.pageOverlay;
      }
    },
    // Sets header mode (fixed, static, toggle)
    header(state, payload) {
      if (payload.mode === 'fixed') {
        state.settings.headerFixed = true;
      } else if (payload.mode === 'static') {
        state.settings.headerFixed = false;
      } else if (payload.mode === 'toggle') {
        state.settings.headerFixed = !state.settings.headerFixed;
      }
    },
    // Sets header style (dark, light, toggle)
    headerStyle(state, payload) {
      if (payload.mode === 'dark') {
        state.settings.headerDark = true;
      } else if (payload.mode === 'light') {
        state.settings.headerDark = false;
      } else if (payload.mode === 'toggle') {
        state.settings.headerDark = !state.settings.headerDark;
      }
    },
    // Sets header search visibility (on, off, toggle)
    headerSearch(state, payload) {
      if (payload.mode === 'on') {
        state.settings.headerSearch = true;
      } else if (payload.mode === 'off') {
        state.settings.headerSearch = false;
      } else if (payload.mode === 'toggle') {
        state.settings.headerSearch = !state.settings.headerSearch;
      }
    },
    // Sets header loader visibility (on, off, toggle)
    headerLoader(state, payload) {
      if (payload.mode === 'on') {
        state.settings.headerLoader = true;
      } else if (payload.mode === 'off') {
        state.settings.headerLoader = false;
      } else if (payload.mode === 'toggle') {
        state.settings.headerLoader = !state.settings.headerLoader;
      }
    },
    // Sets page loader visibility (on, off, toggle)
    pageLoader(state, payload) {
      if (payload.mode === 'on') {
        state.settings.pageLoader = true;
      } else if (payload.mode === 'off') {
        state.settings.pageLoader = false;
      } else if (payload.mode === 'toggle') {
        state.settings.pageLoader = !state.settings.pageLoader;
      }
    },
    // Sets main content mode (full, boxed, narrow)
    mainContent(state, payload) {
      if (payload.mode === 'full') {
        state.settings.mainContent = '';
      } else if (payload.mode === 'boxed') {
        state.settings.mainContent = 'boxed';
      } else if (payload.mode === 'narrow') {
        state.settings.mainContent = 'narrow';
      }
    },
    // Sets active color theme
    setColorTheme(state, payload) {
      // Matches all classes which start with "theme-"
      const regx = new RegExp('\\btheme-[^ ]*[ ]?\\b', 'g');

      // Set new theme
      state.settings.colorTheme = payload.theme || '';

      // Remove all classes which start with "theme-" from body element
      document.body.className = document.body.className.replace(regx, '');

      // If theme is set, add the theme class to body element
      if (payload.theme) {
        document.body.classList.add(`theme-${payload.theme}`);
      }
    },
    startSpinner(state, payload) {
      state.loadingStatus = true;
      state.loadingContent = payload?.content;
    },
    endSpinner(state) {
      state.loadingStatus = false;
      state.loadingContent = null;
    },
    setFromName(state, payload) {
      state.fromName = payload;
    },
    setUserData(state, payload) {
      state.userData = payload ?? null;
    },
    setUsrAssets(state, payload) {
      state.userAssets = payload ?? null;
    },
    setMyTabMenu(state, payload) {
      state.myTabMenu = payload;
    },
    setUsrClover(state, payload) {
      state.usrClover = payload ?? 0;
    },
    setRegTicket(state, payload) {
      state.usrRegTicket = payload ?? 0;
    },
    setLoginState(state, payload) {
      state.isLogin = payload?.isLogin ?? false;
      state.userId = payload?.nickName ?? payload?.email?.split('@')[0] ?? '';
      state.isTodayAttendance = payload?.isTodayAttendance ?? false;
      state.isLandingEventModal = payload?.isTodayAttendance ?? false;
      state.isLandingEvent = payload?.landing_event ?? false;
      // state.isEventAttendance = payload?.isEventAttendance ?? false;
      state.visitFirst = payload?.visit_first ?? false;
      state.newNoti = payload?.newNoti ?? false;
      state.newProperty = payload?.newProperty ? helpers.readProperty() : false;
      state.isPhone = payload?.is_phone ?? false;
      state.cnt_attendance = payload?.attendCount ?? 0;
      state.total_token = payload?.total_token ?? 0;
      state.userCode = payload?.user_code ?? '';
      state.niceAuth = payload?.niceAuth ?? false;
    },
    setOwnAptCnt(state, payload) {
      state.ownAptCnt = [...payload];
    },
    setVM(state, { vm }) {
      state.vm = vm;
    },
    setBadgeValue(state, payload) {
      state.badgeValue = payload;
    },
    setBadgeState(state, payload) {
      state.badgeState = payload;
    },
    setOMCupdateState(state, payload) {
      state.omcUpdate = payload;
    },
    setOmcupdateZIndex(state, z_index) {
      state.totalTokenZIndex = z_index;
    },
    setTotalToken(state, total_token) {
      state.total_token = String(total_token);
    },
    setPhoneAuthModalState(state, { shown }) {
      state.showPhoneAuth = shown;
    },
    setNewCommunityState(state, { community }) {
      state.newCommunity = community;
    },
    setInnerHeight(state, { innerHeight }) {
      state.innerHeight = innerHeight;
    },
    setLanguage(state, language) {
      console.log('setLanguage: language', language);
      const lang = language.replace(/\s/g, '').trim();

      state.lang = lang;

      window.scrollTo({ top: 0, behavior: 'auto' });

      setLocalLang(lang);

      i18n.locale = lang;
      this._vm.$axios.defaults.headers.Lang = lang;
    },
    setGlobalErrorModal(state, globalErrorModal) {
      state.globalErrorModal = globalErrorModal;
    },
  },
  actions: {
    async delay(x, ms) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, ms);
      });
    },
    async logout({ commit }) {
      try {
        await this._vm.$axios.get(`${process.env.VUE_APP_TEST_SERVER}/logout`);

        Cookies.remove('isLogin', {
          domain: '.openmeta.city', // 루트 도메인
        });
        localStorage.removeItem('isLogin');

        commit('setLoginState');
        return;
      } catch (error) {
        return;
      }
    },
    getCityName({ commit }) {
      return new Promise((resolve) => {
        this._vm.$axios.get(`${process.env.VUE_APP_TEST_SERVER}/event/map/city`).then((res) => {
          const { data } = res;
          commit('setCity', data.city);
          localStorage.setItem('city', JSON.stringify(data.city));
          resolve();
        });
      });
    },
    async getHolidayName({ commit }) {
      try {
        const { data: holiday } = await this._vm.$axios.get(`${process.env.VUE_APP_TEST_SERVER}/holidayEvent`);
        commit('setHoliday', holiday);
        localStorage.setItem('holiday', JSON.stringify(holiday));

        return;
      } catch {
        return;
      }
    },
    async getUsrRegTicketsCnt({ commit }) {
      try {
        const { data: resData } = await this._vm.$axios.get(
          `${process.env.VUE_APP_TEST_SERVER}/user/registerationticket`,
          helpers.loginHeaders()
        );
        const { data: regTicket } = { ...resData };

        commit('setRegTicket', regTicket);
        return regTicket;
      } catch (error) {
        commit('setRegTicket');
        return;
      }
    },
    async getOMC({ commit, dispatch }) {
      try {
        const {
          data: { total_token },
        } = await this._vm.$axios.get(`${process.env.VUE_APP_TEST_SERVER}/user/token`);

        commit('setOMCupdateState', true);

        await dispatch('delay', 1300);
        commit('setOmcupdateZIndex', 1041);
        commit('setTotalToken', total_token);
        commit('setOMCupdateState', false);

        await dispatch('delay', 100);
        commit('setOmcupdateZIndex', 11);

        return;
      } catch (error) {
        return;
      }
    },
    async updateOMC({ commit }) {
      try {
        const {
          data: { total_token },
        } = await this._vm.$axios.get(`${process.env.VUE_APP_TEST_SERVER}/user/token`);

        commit('setTotalToken', total_token);

        return;
      } catch (error) {
        return;
      }
    },
    async getUsrClover({ commit }) {
      try {
        const { data: resData } = await this._vm.$axios.get(
          `${process.env.VUE_APP_TEST_SERVER}/user/clover`,
          helpers.loginHeaders()
        );
        const { data: clover } = { ...resData };

        commit('setUsrClover', clover);

        return clover;
      } catch (error) {
        commit('setUsrClover');

        return;
      }
    },
    async getLoginState({ commit, dispatch }) {
      if (IS_LOCAL) {
        commit('setLoginState', {
          isLogin: true,
        });

        return;
      }

      try {
        const {
          data: { data },
        } = await this._vm.$axios.get(`${process.env.VUE_APP_TEST_SERVER}/isauth`, helpers.loginHeaders());
        await dispatch('getUsrClover');
        const loginState = {
          isLogin: true,
          ...data,
        };

        commit('setLoginState', loginState);

        const now = DateTime.now().toISO();

        // 쿠키에 로그인 상태가 있으면 삭제
        if (Cookies.get('isLogin')) Cookies.remove('isLogin', { domain: '.openmeta.city' });
        // 로컬 스토리지에 로그인 상태가 있으면 삭제
        if (localStorage.getItem('isLogin')) localStorage.removeItem('isLogin');

        // 쿠키에 로그인 상태 업데이트
        Cookies.set('isLogin', now, {
          domain: '.openmeta.city', // 루트 도메인
          expires: 1, // 1일간 유지
          secure: true, // HTTPS에서만 작동
          sameSite: 'strict',
        });
        // 로컬 스토리지에 로그인 상태 업데이트
        localStorage.setItem('isLogin', now);

        return;
      } catch (error) {
        commit('setLoginState');
        commit('setUsrClover');
        throw error;
      }
    },
    changeRoutePath() {
      const { name } = { ...router.app._route };
      if (name.includes('Mobile') && name.includes('My')) router.go(-1);
    },
    async getUserData({ commit }) {
      if (IS_LOCAL) {
        return commit('setUserData', {
          name: '1111',
          email: '1111@primeblock.co',
          userCode: '1111',
          ticket: 40,
          link: 'https://localhost:8080/invitation',
          attendance: 5,
          following: 0,
          reward: 0,
          rewardOmc: 5,
          mySns: '구글',
          invite_code_state: false,
          phoneNumber: '',
          subscribe: true,
          lottoTicket: 0,
          twitterId: null,
        });
      }
      try {
        const {
          data: { data: usrData },
        } = await this._vm.$axios.get(`${process.env.VUE_APP_TEST_SERVER}/user/info`);

        commit('setUserData', usrData);

        return;
      } catch (error) {
        commit('setUserData');

        return;
      }
    },
    async getUsrAssets({ commit }) {
      try {
        const { data } = await this._vm.$axios.get(`${process.env.VUE_APP_TEST_SERVER}/user/property/info`);
        commit('setUsrAssets', data);
        return;
      } catch {
        commit('setUsrAssets');
      }
      return;
    },
    async getOwnAptCnt({ commit }) {
      try {
        const response = await this._vm.$axios.get(`${process.env.VUE_APP_TEST_SERVER}/user/property/rank`);

        const { data } = { ...response.data };
        commit('setOwnAptCnt', data);
        return;
      } catch (error) {
        console.error(error);
      }
    },
    async getUserLang() {
      const {
        data: { usrLang },
      } = await this._vm.$axios.get(`${process.env.VUE_APP_TEST_SERVER}/user/lang`);

      return usrLang;
    },
    async fetchUserLang({ commit, dispatch }) {
      const lang = getLang();

      try {
        const usrLang = await dispatch('getUserLang');

        if (usrLang === null) await dispatch('updateUserLang', { lang });

        console.log('fetchUserLang: success: usrLang', usrLang);
        commit('setLanguage', usrLang || lang);
        return;
      } catch (e) {
        console.error(e);
        console.log('fetchUserLang: error');
        commit('setLanguage', lang);
        return;
      }
    },
    async updateUserLang(_, { lang }) {
      await this._vm.$axios.post(`${process.env.VUE_APP_TEST_SERVER}/user/changeLang`, { lang });
      return;
    },
    async getNftDetail({ commit }, nftId) {
      const { data: nftDetail } = await this._vm.$axios.get(`${process.env.VUE_APP_TEST_SERVER}/user/property/detail`, {
        params: { nftId: nftId },
      });

      commit('setNftDetailData', nftDetail);

      return nftDetail;
    },
    async getWeekEvent({ commit }) {
      try {
        const { data } = await this._vm.$axios.get(`${process.env.VUE_APP_TEST_SERVER}/rewardEvent`);

        commit('setIsEvent', data);

        return;
      } catch (error) {
        console.error(error);
      }
    },
  },
});
